import groupBy from 'lodash/groupBy';
import uniqBy from 'lodash/uniqBy';
import {
  COGNITO_LOGOUT,
  EMPTY_ARRAY,
  EMPTY_OBJECT,
  LOAD_LICENSES,
  SET_SUBSCRIPTION,
  SET_PROFILE_IMAGE_SRC,
} from '../constants';

const DEFAULT_STATE = {
  subscription: EMPTY_OBJECT,
  licenses: EMPTY_ARRAY,
  profileImageSrc: undefined,
};

export default function(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case COGNITO_LOGOUT:
      return {
        ...state,
        subscription: DEFAULT_STATE.subscription,
        licenses: DEFAULT_STATE.licenses,
      };
    case LOAD_LICENSES:
      return {
        ...state,
        licenses: uniqBy(
          [...state.licenses, ...action.payload],
          license => `${license.clipId}_${license.licensedAt}`,
        ),
      };
    case SET_SUBSCRIPTION:
      return {
        ...state,
        subscription: action.payload,
      };
    case SET_PROFILE_IMAGE_SRC:
      if (action.payload === state.profileImageSrc) {
        return state;
      } else {
        return {
          ...state,
          profileImageSrc: action.payload,
        };
      }
    default:
      return state;
  }
}

// TODO: Purge data on logout.



// WEBPACK FOOTER //
// ./src/reducers/user.js